import React, { FC } from 'react';
import styles from '../AnnotationForm.module.scss';

type Props = {
  user: string;
  date: string;
};

const ModifiedBy: FC<Props> = ({ user, date }) => {
  return (
    <div className={styles.modifiedByContainer}>
      <span className={styles.modifiedBy}>
        Last modified by: {user} on {date}
      </span>
    </div>
  );
};

export default ModifiedBy;
